export default __webpack_public_path__ + "bb4b07ec5ff2c7a39c1ac3a445f3d060.png";